export const SEGMENTER_MODEL_IDS = ['landscape', 'general', 'multiclass'] as const

export type SegmenterModelId = (typeof SEGMENTER_MODEL_IDS)[number]

export function isSegmenterModelId(value: unknown): value is SegmenterModelId {
  return (SEGMENTER_MODEL_IDS as readonly unknown[]).includes(value)
}

export type SegmenterTier = 'light' | 'heavy'

export const SEGMENTER_TIERS: Record<SegmenterTier, SegmenterModelId> = {
  light: 'landscape',
  heavy: 'multiclass',
}

export type SegmenterPlatform = 'phone' | 'desktop'

export interface FrameShape {
  width: number
  height: number
}

export const PHONE_SEGMENTER_MODELS = {
  upright: 'general',
  wide: 'landscape',
} as const satisfies Record<string, SegmenterModelId>

export function modelForShape(shape: FrameShape): SegmenterModelId {
  return shape.height >= shape.width ? PHONE_SEGMENTER_MODELS.upright : PHONE_SEGMENTER_MODELS.wide
}

// The file each id resolves to is an asset fact, not a decision: it lives beside the
// same-origin paths the web serves, which a Ruby spec pins against the files on disk.
export interface SegmenterTierFiles {
  light: string
  heavy: string
}
